(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jive-creatine-midlife-reset"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jive-symptom-checklist')) {
    class JiveSymptomChecklist extends HTMLElement {
      connectedCallback() {
        this.inputs = [...this.querySelectorAll('input[type="checkbox"]')];
        this.output = this.querySelector('output');
        this.addEventListener('change', () => this.update());
        this.update();
      }

      update() {
        const count = this.inputs.filter((input) => input.checked).length;
        const template = count === 0
          ? this.dataset.emptyCopy
          : count === 1
            ? this.dataset.oneCopy
            : this.dataset.manyCopy;

        if (this.output) this.output.textContent = template.replace('{count}', String(count));
      }
    }

    customElements.define('jive-symptom-checklist', JiveSymptomChecklist);
  }

  if (!customElements.get('jive-reset-quiz')) {
    class JiveResetQuiz extends HTMLElement {
      connectedCallback() {
        this.steps = [...this.querySelectorAll('[data-quiz-step]')];
        this.progress = [...this.querySelectorAll('.midlife-quiz__progress span')];
        this.result = this.querySelector('[data-quiz-result]');
        this.currentStep = 0;
        this.classList.add('is-enhanced');
        this.addEventListener('change', (event) => this.handleChange(event));
        this.addEventListener('click', (event) => this.handleClick(event));
        this.showStep(0, false);
      }

      handleChange(event) {
        if (!event.target.matches('input[type="radio"]')) return;
        const step = event.target.closest('[data-quiz-step]');
        const button = step?.querySelector('[data-quiz-next], [data-quiz-finish]');
        if (button) button.disabled = false;
      }

      handleClick(event) {
        const next = event.target.closest('[data-quiz-next]');
        const back = event.target.closest('[data-quiz-back]');
        const finish = event.target.closest('[data-quiz-finish]');

        if (next) this.showStep(this.currentStep + 1, true);
        if (back) this.showStep(this.currentStep - 1, true);
        if (finish) this.showResult();
      }

      showStep(index, focusLegend) {
        this.currentStep = Math.max(0, Math.min(index, this.steps.length - 1));
        this.steps.forEach((step, stepIndex) => {
          const active = stepIndex === this.currentStep;
          step.classList.toggle('is-active', active);
          step.hidden = !active;
        });
        this.progress.forEach((item, itemIndex) => item.classList.toggle('is-current', itemIndex === this.currentStep));
        if (this.result) this.result.hidden = true;
        if (focusLegend) this.steps[this.currentStep]?.querySelector('legend')?.focus?.();
      }

      showResult() {
        const yesCount = this.querySelectorAll('input[value="yes"]:checked').length;
        const qualified = this.querySelector('[data-qualified-result]');
        const alternate = this.querySelector('[data-alternate-result]');

        this.steps.forEach((step) => { step.hidden = true; });
        if (qualified) qualified.hidden = yesCount < 2;
        if (alternate) alternate.hidden = yesCount >= 2;
        if (this.result) {
          this.result.hidden = false;
          this.result.focus?.();
        }
      }
    }

    customElements.define('jive-reset-quiz', JiveResetQuiz);
  }

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.midlife-reset__solution-video').forEach((video) => {
      video.play().catch(() => {});
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jive-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.pdp-top');
    roots.forEach(function (root) {
      var track = root.querySelector('.gal-track');
      var thumbs = root.querySelectorAll('.gal-thumb');
      var prevBtn = root.querySelector('.gal-prev');
      var nextBtn = root.querySelector('.gal-next');

      // Paint guard: the eager hero image inside this scroll-snap flex track can
      // load but intermittently fail to paint on first render, leaving a blank main
      // image while the thumbnails + arrow still show (a refresh forces the paint).
      // Force-decode the hero, then nudge a compositor repaint so it always shows.
      if (track) {
        var heroImg = track.querySelector('.gal-slide img');
        if (heroImg) {
          var repaint = function () {
            track.style.transform = 'translateZ(0)';
            window.requestAnimationFrame(function () { track.style.transform = ''; });
          };
          var ensurePaint = function () {
            if (heroImg.decode) { heroImg.decode().then(repaint).catch(repaint); } else { repaint(); }
          };
          if (heroImg.complete && heroImg.naturalWidth > 0) { ensurePaint(); }
          else { heroImg.addEventListener('load', ensurePaint, { once: true }); }
        }
      }

      // Static rating row: smooth-scroll to the review carousel when present
      // (the plain #anchor jump stays as the no-JS fallback).
      var ratingLink = root.querySelector('.pdp-rating--static');
      if (ratingLink) {
        ratingLink.addEventListener('click', function (e) {
          var target = document.getElementById('jive-review-carousel');
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      // Lazy gallery videos (any number: per-slot videos and the legacy injected
      // one): zero mp4 bytes at page load. The first time a video slide scrolls
      // into view (swipe, arrow, or thumb tap) its <source data-src> is promoted
      // to src, then it plays muted+looped. It pauses off-screen, and a tap
      // toggles play/pause. Respects prefers-reduced-motion (tap-to-play only).
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var vidCtls = (track ? Array.prototype.slice.call(track.querySelectorAll('.gal-slide--video')) : []).map(function (slide) {
        var vid = slide.querySelector('video');
        var srcEl = vid ? vid.querySelector('source[data-src]') : null;
        if (!vid) return null;
        var loadVid = function () {
          if (srcEl && !srcEl.getAttribute('src')) {
            srcEl.setAttribute('src', srcEl.getAttribute('data-src'));
            vid.load();
          }
        };
        var playVid = function () {
          loadVid();
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
        };
        vid.addEventListener('playing', function () { slide.classList.add('is-playing'); });
        vid.addEventListener('pause', function () { slide.classList.remove('is-playing'); });
        slide.addEventListener('click', function () {
          if (vid.paused) { playVid(); } else { vid.pause(); }
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting && e.intersectionRatio >= 0.5) {
                if (!reduceMotion) playVid();
              } else if (!e.isIntersecting && !vid.paused) {
                vid.pause();
              }
            });
          }, { threshold: [0, 0.5] }).observe(slide);
        }
        return { slide: slide, vid: vid, play: playVid };
      }).filter(Boolean);

      if (track && track.children.length > 1) {
        var slideW = function () { return track.clientWidth || 1; };
        var count = function () { return track.children.length; };
        var indexNow = function () { return Math.round(track.scrollLeft / slideW()); };
        var capSpans = root.querySelectorAll('.gal-cap [data-cap]');
        var sync = function () {
          var i = indexNow();
          thumbs.forEach(function (t, ti) { t.setAttribute('aria-selected', ti === i ? 'true' : 'false'); });
          capSpans.forEach(function (s) {
            var on = parseInt(s.getAttribute('data-cap'), 10) === i && s.textContent !== '';
            s.classList.toggle('is-on', on);
          });
          if (prevBtn) prevBtn.disabled = i <= 0;
          if (nextBtn) nextBtn.disabled = i >= count() - 1;
          // Deterministic video start/stop on the settled slide index (the
          // IntersectionObserver still covers vertical page scrolling).
          vidCtls.forEach(function (c) {
            var vi = Array.prototype.indexOf.call(track.children, c.slide);
            if (i === vi) { if (!reduceMotion) c.play(); }
            else if (!c.vid.paused) { c.vid.pause(); }
          });
        };
        var raf;
        track.addEventListener('scroll', function () {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(sync);
        }, { passive: true });
        if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -slideW(), behavior: 'smooth' }); });
        if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: slideW(), behavior: 'smooth' }); });
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            var i = parseInt(t.getAttribute('data-i'), 10) || 0;
            track.scrollTo({ left: i * slideW(), behavior: 'smooth' });
          });
        });
        window.addEventListener('resize', sync);
        sync();
      }

      // Accordion behavior is owned by the shared handler in assets/jive.js (animates via
      // max-height + enforces single-open). A second handler here double-toggled aria-expanded,
      // which left items stuck open. Intentionally not bound here.
    });
  })();

  /* ===== Click-to-zoom lightbox for PDP gallery images =====
     One click opens a fullscreen viewer of that image; a second click/tap (or scroll
     wheel on desktop) zooms in at that point, then drag to pan. Esc / backdrop / X close.
     Built once, shared by every gallery on the page, progressive-enhancement only. */
  (function () {
    var MAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.4-3.4"/><path d="M11 8v6M8 11h6"/></svg>';
    var isTouch = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);

    var galleries = [];
    document.querySelectorAll('.pdp-top .gal-stage').forEach(function (stage) {
      var imgEls = Array.prototype.slice.call(stage.querySelectorAll('.gal-slide img'));
      if (!imgEls.length) return;
      var track = stage.querySelector('.gal-track');
      var list = imgEls.map(function (im) {
        var src = im.currentSrc || im.src || '';
        var hi = src.replace(/([?&]width=)\d+/i, '$1' + '1800');
        if (hi === src && src) { hi = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1800'; }
        return { src: hi, fallback: src, alt: im.getAttribute('alt') || '' };
      });
      // Video slides hold track positions but are NOT in the zoomable image list,
      // so slide index and list index diverge. Record each image's slide index.
      var imgSlideIdx = imgEls.map(function (im) {
        var slide = im.closest ? im.closest('.gal-slide') : null;
        return (track && slide) ? Array.prototype.indexOf.call(track.children, slide) : 0;
      });
      galleries.push({ stage: stage, track: track, list: list, imgs: imgEls, imgSlideIdx: imgSlideIdx });
    });
    if (!galleries.length) return;

    var ZOOM = 2.6, MAXSCALE = 4;
    var lb = document.createElement('div');
    lb.className = 'jz-lb';
    lb.setAttribute('hidden', '');
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product image viewer');
    lb.innerHTML =
      '<div class="jz-canvas"><img class="jz-img" alt="" draggable="false"></div>' +
      '<button class="jz-btn jz-close" type="button" aria-label="Close image viewer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<button class="jz-btn jz-nav jz-prev" type="button" aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button class="jz-btn jz-nav jz-next" type="button" aria-label="Next image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="jz-count" hidden></div>' +
      '<div class="jz-hint"></div>';
    document.body.appendChild(lb);

    var canvas = lb.querySelector('.jz-canvas');
    var img = lb.querySelector('.jz-img');
    var closeBtn = lb.querySelector('.jz-close');
    var prevBtn = lb.querySelector('.jz-prev');
    var nextBtn = lb.querySelector('.jz-next');
    var countEl = lb.querySelector('.jz-count');
    var hintEl = lb.querySelector('.jz-hint');

    var cur = null, idx = 0, scale = 1, tx = 0, ty = 0, lastFocus = null, hintTimer = null, closeTimer = null;

    function apply(anim) {
      img.style.transition = anim ? '' : 'none';
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      img.classList.toggle('jz-zoomed', scale > 1.01);
    }
    function limit() {
      var bx = Math.max(0, (img.clientWidth * scale - window.innerWidth) / 2 + 24);
      var by = Math.max(0, (img.clientHeight * scale - window.innerHeight) / 2 + 24);
      if (tx > bx) tx = bx; if (tx < -bx) tx = -bx;
      if (ty > by) ty = by; if (ty < -by) ty = -by;
    }
    function reset(anim) { scale = 1; tx = 0; ty = 0; limit(); apply(anim); }
    function zoomAt(ns, px, py) {
      ns = Math.max(1, Math.min(MAXSCALE, ns));
      var ox = (px - window.innerWidth / 2 - tx) / scale;
      var oy = (py - window.innerHeight / 2 - ty) / scale;
      tx = (px - window.innerWidth / 2) - ns * ox;
      ty = (py - window.innerHeight / 2) - ns * oy;
      scale = ns; limit(); apply(true);
    }
    function show(i) {
      idx = (i + cur.list.length) % cur.list.length;
      var item = cur.list[idx];
      reset(false);
      // Show the already-cached gallery image immediately (no blank flash), then
      // silently swap in the higher-res version for crisp zoom once it has loaded.
      var base = item.fallback || item.src;
      img.onerror = null;
      img.src = base;
      img.alt = item.alt;
      if (item.src && item.src !== base) {
        var want = idx, hi = new Image();
        hi.onload = function () {
          if (idx === want && !lb.hasAttribute('hidden')) { img.src = item.src; }
        };
        hi.src = item.src;
      }
      var multi = cur.list.length > 1;
      prevBtn.hidden = !multi; nextBtn.hidden = !multi; countEl.hidden = !multi;
      if (multi) countEl.textContent = (idx + 1) + ' / ' + cur.list.length;
    }
    function flashHint() {
      hintEl.innerHTML = MAG + '<span>' + (isTouch ? 'Tap to zoom, drag to explore' : 'Click to zoom, scroll to get closer') + '</span>';
      hintEl.classList.remove('jz-fade');
      if (hintTimer) clearTimeout(hintTimer);
      hintTimer = setTimeout(function () { hintEl.classList.add('jz-fade'); }, 2800);
    }
    function open(g, i) {
      cur = g;
      lastFocus = document.activeElement;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      lb.removeAttribute('hidden');
      document.documentElement.classList.add('jz-lock');
      document.body.classList.add('jz-lock');
      void lb.offsetWidth;
      lb.classList.add('jz-open');
      show(i);
      flashHint();
      closeBtn.focus();
    }
    function close() {
      lb.classList.remove('jz-open');
      document.documentElement.classList.remove('jz-lock');
      document.body.classList.remove('jz-lock');
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { lb.setAttribute('hidden', ''); }, 240);
      if (cur && cur.track) {
        // Image-list index -> that image's actual slide index.
        var slideIdx = (cur.imgSlideIdx && cur.imgSlideIdx[idx] != null) ? cur.imgSlideIdx[idx] : idx;
        var to = slideIdx * (cur.track.clientWidth || 1);
        try { cur.track.scrollTo({ left: to, behavior: 'auto' }); } catch (e) { cur.track.scrollLeft = to; }
      }
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }

    galleries.forEach(function (g) {
      g.imgs.forEach(function (im, i) { im.addEventListener('click', function () { open(g, i); }); });
      var badge = document.createElement('button');
      badge.type = 'button';
      badge.className = 'gal-zoom-hint';
      badge.setAttribute('aria-label', 'Zoom image');
      badge.innerHTML = MAG + '<span>' + (isTouch ? 'Tap to zoom' : 'Click to zoom') + '</span>';
      badge.addEventListener('click', function (e) {
        e.preventDefault();
        var s = g.track ? Math.round(g.track.scrollLeft / (g.track.clientWidth || 1)) : 0;
        // Slide index -> image-list index. On a video slide (no exact match),
        // fall back to the nearest earlier image.
        var li = g.imgSlideIdx.indexOf(s);
        if (li < 0) {
          li = 0;
          for (var k = 0; k < g.imgSlideIdx.length; k++) {
            if (g.imgSlideIdx[k] < s) li = k;
          }
        }
        open(g, li);
      });
      g.stage.appendChild(badge);
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    canvas.addEventListener('click', function (e) { if (e.target === canvas) close(); });

    var down = false, moved = false, sx = 0, sy = 0, stx = 0, sty = 0, pid = null;
    img.addEventListener('pointerdown', function (e) {
      down = true; moved = false; pid = e.pointerId;
      sx = e.clientX; sy = e.clientY; stx = tx; sty = ty;
      if (img.setPointerCapture) { try { img.setPointerCapture(pid); } catch (_) {} }
      if (scale > 1.01) img.classList.add('jz-drag');
      e.preventDefault();
    });
    img.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
      if (scale > 1.01) { tx = stx + dx; ty = sty + dy; limit(); apply(false); }
    });
    function endPointer(e) {
      if (!down) return;
      down = false;
      img.classList.remove('jz-drag');
      if (pid != null && img.releasePointerCapture) { try { img.releasePointerCapture(pid); } catch (_) {} }
      if (!moved) {
        if (scale > 1.01) reset(true);
        else zoomAt(ZOOM, e.clientX, e.clientY);
      }
    }
    img.addEventListener('pointerup', endPointer);
    img.addEventListener('pointercancel', function () { down = false; img.classList.remove('jz-drag'); });
    canvas.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomAt(scale * (e.deltaY < 0 ? 1.18 : 1 / 1.18), e.clientX, e.clientY);
    }, { passive: false });

    document.addEventListener('keydown', function (e) {
      if (lb.hasAttribute('hidden')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && !prevBtn.hidden) show(idx - 1);
      else if (e.key === 'ArrowRight' && !nextBtn.hidden) show(idx + 1);
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = [closeBtn, prevBtn, nextBtn].filter(function (b) { return !b.hidden; });
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    });
    window.addEventListener('resize', function () { if (!lb.hasAttribute('hidden')) { limit(); apply(false); } });
    img.addEventListener('load', function () { limit(); apply(false); });
  })();

  /* Loved By Thousands strip: tap a card to play/pause; the sound button toggles mute
     (and mutes the others). Videos start muted so they can paint the first frame. */
  (function () {
    document.querySelectorAll('.bb-vids-track').forEach(function (track) {
      function playOnly(video, card) {
        track.querySelectorAll('video').forEach(function (x) { if (x !== video) x.pause(); });
        track.querySelectorAll('.bb-play').forEach(function (b) { b.style.display = ''; });
        var pr = video.play(); if (pr && pr.catch) { pr.catch(function () {}); }
        var pb = card.querySelector('.bb-play'); if (pb) pb.style.display = 'none';
      }
      track.addEventListener('click', function (e) {
        var snd = e.target.closest('.bb-sound');
        if (snd) {
          e.preventDefault(); e.stopPropagation();
          var scard = snd.closest('.bb-vc'); var sv = scard && scard.querySelector('video'); if (!sv) return;
          var willUnmute = sv.muted;
          track.querySelectorAll('video').forEach(function (x) { x.muted = true; });
          track.querySelectorAll('.bb-sound').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Unmute video'); });
          if (willUnmute) {
            sv.muted = false; snd.setAttribute('aria-pressed', 'true'); snd.setAttribute('aria-label', 'Mute video');
            if (sv.paused) playOnly(sv, scard);
          }
          return;
        }
        var card = e.target.closest('.bb-vc'); if (!card) return;
        var v = card.querySelector('video'); if (!v) return;
        e.preventDefault();
        var btn = card.querySelector('.bb-play');
        if (v.paused) { playOnly(v, card); }
        else { v.pause(); if (btn) btn.style.display = ''; }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
